import { Dialog, DialogContent, DialogActions, DialogTitle, IconButton, Divider } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '../new/Button';
import { Typography } from '../new/Typography';
interface CancelFormCreationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const CancelFormCreationDialog: React.FC<CancelFormCreationDialogProps> = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          background: '#ffffff',
          minWidth: '37.5rem',
        },
      }}
    >
      <DialogTitle>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ color: '#140838', fontSize: '1.125rem', fontWeight: 500 }}>Discard Mailing?</Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={14}>If you close this form now, all progress will be lost.</Typography>
      </DialogContent>
      <Divider sx={{ color: '#D6D6D6' }} />
      <DialogActions sx={{ padding: '1rem 1.5rem', paddingLeft: '40%' }}>
        <Button type="outline" onClick={onClose}>
          Return to Mailing
        </Button>
        <Button type="primary" onClick={onSubmit}>
          Discard Mailing
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelFormCreationDialog;
